export type Buyer = {
  name: string
  location: string
  minutesAgo: number
}

export const buyers: Buyer[] = [
  { name: 'Martín Gutiérrez', location: 'Córdoba, Argentina', minutesAgo: 2 },
  { name: 'Lucía Fernández', location: 'Sevilla, España', minutesAgo: 6 },
  { name: 'Andrés Molina', location: 'Guadalajara, México', minutesAgo: 11 },
  { name: 'Camila Restrepo', location: 'Medellín, Colombia', minutesAgo: 4 },
  { name: 'Joaquín Salazar', location: 'Viña del Mar, Chile', minutesAgo: 9 },
  { name: 'Sofía Navarro', location: 'Valencia, España', minutesAgo: 3 },
  { name: 'Gonzalo Ibáñez', location: 'Montevideo, Uruguay', minutesAgo: 14 },
  { name: 'Valentina Ortiz', location: 'Rosario, Argentina', minutesAgo: 7 },
  { name: 'Tomás Herrera', location: 'Lima, Perú', minutesAgo: 5 },
  { name: 'Emilia Vargas', location: 'San José, Costa Rica', minutesAgo: 12 },
]
